const api = `${process.env.PUBLIC_URL}/json-data`;
export const Products = `${api}/products.json`;
export const Categories = `${api}/categories.json`;
